import identity from 'lodash/identity';
import { Formattable } from './types';

export default function useFormattable<T>(
  value: T | undefined,
  props: Formattable<T>,
) {
  const { formatter = identity } = props;
  return formatter(value);
}
